import { createFileRoute } from "@tanstack/react-router";
import WhatIsCargoNova from "@/pages/WhatIsCargoNova";
import { pageHead } from "@/lib/seo";
import { whatIsCargoNovaBreadcrumb } from "@/utils/schema";

export const Route = createFileRoute("/th/what-is-cargonova")({
  head: () => ({
    ...pageHead("/what-is-cargonova", "th"),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(whatIsCargoNovaBreadcrumb("th")),
      },
    ],
  }),
  component: WhatIsCargoNova,
});
